import { render } from "./OlvidePassword.vue?vue&type=template&id=54e8ae88&scoped=true"
import script from "./OlvidePassword.vue?vue&type=script&lang=js"
export * from "./OlvidePassword.vue?vue&type=script&lang=js"

import "./OlvidePassword.vue?vue&type=style&index=0&id=54e8ae88&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54e8ae88"]])

export default __exports__